/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import { useEffect, useState } from "react";
import { NavLink as NavLinkRRD, Link, useNavigate } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import './Sidebar.css'

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col,
} from "reactstrap";

import secureLocalStorage from "react-secure-storage";
import { getAccountApps, logout, getImage } from "../../network/ApiAxios";
import { formatInitialsName } from "../../utils/views/pages/InitialsFormat.js"
import { useUserImage } from "../../views/pages/LandingPage/Context/UserImageContext";


import voiceConditioningImg from 'assets/img/brand/voice conditioning.png';
import elcarImg from 'assets/img/brand/elcar.png';
import defaultAppImg from 'assets/img/brand/aircode-icon.png';
import appsIcon from "assets/img/icons/common/app-icon.svg";


const Sidebar = (props) => {

  const user = JSON.parse(secureLocalStorage.getItem("user"));
  const initials = formatInitialsName(user.name);
  const { imageContent, refreshImage, clearCache } = useUserImage();


  const navigate = useNavigate();

  const [collapseOpen, setCollapseOpen] = useState();
  const [apps, setApps] = useState([]);
  const [loadingApps, setLoadingApps] = useState();
  const [dropdownOpenDesktop, setDropdownOpenDesktop] = useState(false);
  const [dropdownOpenMobile, setDropdownOpenMobile] = useState(false);
  const app = JSON.parse(secureLocalStorage.getItem("app"));
  const [currentApp, setCurrentApp] = useState();

  useEffect(() => {
    if (user.image) {
      refreshImage(user.image);
    }
    const fetchApps = async () => {
      try {
        setLoadingApps(true);
        let params = { filter: { account: user.account } };
        const response = await getAccountApps(params);
        const { data } = response;

        if (data.success) {     
          
          //carregando as imagens dos apps
          let apps = data.account.apps
          let appsLoaded = []
          let selectedApp = null  //app default para mostrar
          for(let i=0; i<apps.length; i++){            
            const response = await getImage(apps[i]?.image);
            const { data } = response;
            //versão de apps com imagens carregadas
            appsLoaded.push({...apps[i], ...{imageSource: data}})

            //definindo o app selecionado para mostrar na sidebar
            if(apps[i]._id == app?._id){
              selectedApp=appsLoaded[i]
            }
          }      
          setCurrentApp(selectedApp)    
          setApps(appsLoaded);          
        }
      } catch (error) {
        console.error(error)
      } finally {
        setLoadingApps(false);
      }

    }

    fetchApps();
    checkStoredApp();

  }, []);

  // Verifica se há um app no localStorage e atualiza o state
  const checkStoredApp = () => {
    const storedApp = secureLocalStorage.getItem("app");
    if (storedApp) {
      const parsedApp = JSON.parse(storedApp);
      if (parsedApp?._id !== currentApp?._id) {
        setCurrentApp(parsedApp);
      }
    }
  };

  // Função para retornar o nome do app (se quiser customizar)
  const getAppDisplayName = (app) => {
    return app.name; // nome original    
  }


  // Função para retornar a imagem baseada no tipo/nome do app
  const getAppImage = (app) => {
    if (app?.image) {     
      return app.imageSource
    } else {
      return defaultAppImg;
    }

  }

  const handleAppChange = (app) => {
    secureLocalStorage.setItem("app", JSON.stringify(app));
    setCurrentApp(app);
    navigate(0)

  }

  const tryLogOut = async () => {
    const token = secureLocalStorage.getItem("token");

    try {
      const response = await logout(token);
      const { data } = response;

      console.log("DATA:", data)

    } catch (error) {
      console.error("Erro no logout:", error);

    }

    clearCache();
    // Sempre limpar dados locais e redirecionar
    secureLocalStorage.removeItem("token");
    secureLocalStorage.removeItem("user");
    secureLocalStorage.removeItem("app");
    navigate("/home");

  }

  const handleLogOut = (e) => {
    tryLogOut();
  }


  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return props?.location?.pathname.indexOf(routeName) > -1 ? "active" : "";
  };
  // toggles collapse between opened and closed (true/false)
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse
  const closeCollapse = () => {
    setCollapseOpen(false);
  };
  // creates the links that appear in the left menu / Sidebar
  const createLinks = (routes) => {

    return routes.map((prop, key) => {

      if (!prop.sidebarVisible || !app) {
        return null
      }

      return (
        <NavItem key={key}>
          <NavLink
            to={prop.layout + prop.path}
            tag={NavLinkRRD}
            onClick={closeCollapse}
            className={activeRoute(prop.name)}
          >
            {prop.icon.includes('.svg') ? (
              <img src={prop.icon} alt="" className="nav-icon" />
            ) : (
              <i className={prop.icon} />
            )}
            <span className="menuitem">{prop.name}</span>
          </NavLink>
        </NavItem>
      );
    });
  };

  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar-light"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {/* Brand */}
        {logo ? (
          <NavbarBrand className="pt-0 navbar-brand-custom" {...navbarBrandProps}>
            {/* <img
              alt={logo.imgAlt}
              className="navbar-brand-img"
              src={logo.imgSrc}
            /> */}
            Central System
          </NavbarBrand>
        ) : null}

        {/* User */}
        <Nav className="align-items-left d-none d-md-flex" navbar>
          <NavItem>
            <NavLink className="pr-0" to="/admin/user-profile" tag={Link}>
              <Media className="align-items-center">

                {imageContent ? (
                  <span className="avatar avatar-sm rounded-circle">
                    <img
                      alt="..."
                      src={imageContent}
                      className="avatar-icon"
                    />
                  </span>
                ) : (
                  <div className="avatar avatar-sm rounded-circle user-initials">
                    {initials}
                  </div>
                )}


                <Media className="ml-2 d-none d-lg-block">
                  <span className="mb-0 text-dark text-sm font-weight-bold">
                    {user.name}
                  </span>
                </Media>
              </Media>
            </NavLink>
          </NavItem>
        </Nav>


        <Nav className="align-items-center d-md-none">
          <NavItem>
            <NavLink className="pr-0" to="/admin/user-profile" tag={Link}>
              <Media className="align-items-center">

                {imageContent ? (
                  <span className="avatar avatar-sm rounded-circle">
                    <img
                      alt="..."
                      src={imageContent}
                      className="avatar-icon"

                    />
                  </span>
                ) : (
                  <div className="avatar avatar-sm rounded-circle user-initials">
                    {initials}
                  </div>
                )}


                <Media className="ml-2 d-none d-lg-block">
                  <span className="mb-0 text-dark text-sm font-weight-bold">
                    {user.name}
                  </span>
                </Media>
              </Media>
            </NavLink>
          </NavItem>
        </Nav>




        {/* Collapse - versão mobile*/}
        <Collapse id="sidebar-color" navbar isOpen={collapseOpen}>
          {/* Collapse header */}
          <div className="navbar-collapse-header d-md-none px-3">

            <Row>
              {logo ? (
                <Col className="collapse-brand" xs="6">
                  {logo ? (
                    <NavbarBrand className="pt-0 navbar-brand-custom" {...navbarBrandProps}>
                      {/* <img
                        alt={logo.imgAlt}
                        className="navbar-brand-img"
                        src={logo.imgSrc}
                      /> */}
                      Central System
                    </NavbarBrand>
                  ) : null}
                </Col>
              ) : null}

              <Col className="collapse-close align-middle" xs="6">

                <button
                  className="navbar-toggler"
                  type="button"
                  onClick={toggleCollapse}
                >
                  <span />
                  <span />
                </button>
              </Col>
            </Row>
            <Row>
              {/* Dropdown app mobile*/}
              <Nav className="align-items-center d-md-none w-100">
                <UncontrolledDropdown nav className="w-100 px-0" isOpen={dropdownOpenMobile} toggle={() => setDropdownOpenMobile(!dropdownOpenMobile)}>
                  <DropdownToggle className="pr-3 app-dropdown-toggle " nav>
                    <Media className="align-items-center justify-content-between w-100">
                      <div className="d-flex align-items-center">
                        {currentApp && !loadingApps && (
                          <span className="app-icon-small mr-2">
                            <img
                              alt={getAppDisplayName(currentApp)}
                              src={getAppImage(currentApp)}
                              className="app-icon-sidebar"
                              style={{
                                width: '24px',
                                height: '24px',
                                borderRadius: '4px',
                                objectFit: 'cover'
                              }}
                            />
                          </span>
                        )}
                        <Media className="ml-1">
                          <span className="mb-0 text-dark text-sm font-weight-bold">
                            {currentApp ? getAppDisplayName(currentApp) : 'Selecionar App'}
                          </span>
                        </Media>
                      </div>
                      <i className={`ni ${dropdownOpenMobile ? 'ni-bold-up' : 'ni-bold-down'}`} />
                    </Media>
                  </DropdownToggle>

                  <DropdownMenu className="dropdown-menu-arrow w-100 px-2">
                    <DropdownItem className="noti-title" header tag="div">
                      <h6 className="text-overflow m-0">Apps</h6>
                    </DropdownItem>

                    {loadingApps ? (
                      <DropdownItem disabled>
                        <i className="fa fa-spinner fa-spin mr-2" />
                        <span>Loading...</span>
                      </DropdownItem>
                    ) : (
                      apps.map((app) => (
                        <DropdownItem
                          key={app._id}
                          onClick={() => handleAppChange(app)}
                          className={`${currentApp?._id === app._id ? 'active' : ''} my-2`}
                        >
                          <img
                            src={getAppImage(app)}
                            alt={getAppDisplayName(app)}
                            className="mr-2"
                            style={{
                              width: '2rem',
                              height: '2rem',
                              borderRadius: '3px',
                              objectFit: 'cover',
                            }}
                          />
                          <span className="ml-2">{getAppDisplayName(app)}</span>
                        </DropdownItem>
                      ))
                    )}

                    <DropdownItem divider />
                    <DropdownItem tag={Link} to="/admin/home">
                      <img src={appsIcon} className="" />
                      <span className="mx-2">See all your apps</span>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Row>
          </div>

          {/* Form */}
          <Form className="mt-4 mb-3 d-md-none">
            <InputGroup className="input-group-rounded input-group-merge">
              <Input
                aria-label="Search"
                className="form-control-rounded form-control-prepended"
                placeholder="Search"
                type="search"
              />
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <span className="fa fa-search" />
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </Form>

          {/* App Selector Dropdown Desktop */}
          <Nav className="align-items-left d-none d-md-flex mb-4 mt-0" navbar>
            <UncontrolledDropdown nav isOpen={dropdownOpenDesktop} toggle={() => setDropdownOpenDesktop(!dropdownOpenDesktop)}>
              <DropdownToggle className="px-3 app-dropdown-toggle" nav>
                <Media className="align-items-center justify-content-between w-100">
                  <div className="d-flex align-items-center">
                    {currentApp && !loadingApps && (
                      <span className="app-icon-small mr-1">
                        <img
                          alt={getAppDisplayName(currentApp)}
                          src={getAppImage(currentApp)}
                          className="app-icon-sidebar"
                          style={{
                            width: '24px',
                            height: '24px',
                            borderRadius: '4px',
                            objectFit: 'cover'
                          }}
                        />
                      </span>
                    )}
                    <Media className="ml-2">
                      <span className="mb-0 text-dark text-sm font-weight-bold">
                        {currentApp ? getAppDisplayName(currentApp) : 'Selecionar App'}
                      </span>
                    </Media>
                  </div>

                  <i className={`ni ${dropdownOpenDesktop ? 'ni-bold-up' : 'ni-bold-down'}`} />
                </Media>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-arrow p-2" >
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Apps</h6>
                </DropdownItem>

                {loadingApps ? (
                  <DropdownItem disabled>
                    <i className="fa fa-spinner fa-spin mr-2" />
                    <span>Loading...</span>
                  </DropdownItem>
                ) : (
                  apps.map((app) => (
                    <DropdownItem
                      key={app._id}
                      onClick={() => handleAppChange(app)}
                      className={currentApp?._id === app._id ? 'active' : ''}
                    >
                      <img
                        src={getAppImage(app)}
                        alt={getAppDisplayName(app)}
                        className="mr-2"
                        style={{
                          width: '20px',
                          height: '20px',
                          borderRadius: '3px',
                          objectFit: 'cover'
                        }}
                      />
                      <span>{getAppDisplayName(app)}</span>

                    </DropdownItem>
                  ))
                )}

                <DropdownItem divider />
                <DropdownItem tag={Link} to="/admin/home">
                  <img src={appsIcon} className="" />
                  <span className="mx-2">See all your apps</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>

          {/* Navigation */}
          <Nav navbar> {createLinks(routes)}</Nav>
          {/* Divider */}
          <hr className="my-3" />

          <Nav className="mb-md-3 sidebar-logout-fixed" navbar>
            <NavItem>
              <NavLink
                href="#logout"
                onClick={(e) => {
                  e.preventDefault();
                  handleLogOut();
                }}
              >
                <i className="ni ni-user-run" />
                <span>Logout</span>
              </NavLink>
            </NavItem>
          </Nav>

        </Collapse>
      </Container>
    </Navbar>


  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
